import * as Scrivito from "scrivito";
import {
  defaultPageEditingConfigAttributes,
  defaultPageInitialContent,
  defaultPageProperties,
  defaultPageValidations,
  defaultPropertiesGroups,
} from "objs/_defaultPageEditingConfig";
import {
  metadataConfiguratorInitialContent,
  metadataEditingConfigAttributes,
  metadataConfiguratorPropertiesGroups,
  metadataValidations,
} from "objs/_metadataEditingConfig";

Scrivito.provideEditingConfig("ProjectListSame", {
  title: "Project list Same",
  attributes: {
    ...metadataEditingConfigAttributes,
    ...defaultPageEditingConfigAttributes,
    redirectToProjectCreate: {
      title: "Redirection target after project creation",
      description:
        "Reference where user should be redirected after Project creation",
    },
    redirectToProjectItem: {
      title: "Redirection target after click on Project item",
      description:
        "Reference where user should be redirected after click on the Project item",
    },
  },
  properties: [
    ...defaultPageProperties,
    "redirectToProjectCreate",
    "redirectToProjectItem",
  ],
  propertiesGroups: [
    {
      title: "Advanced",
      properties: [],
    },
    ...defaultPropertiesGroups,
    {
      title: "Translations",
      properties: ["createNewProject"],
    },
    ...metadataConfiguratorPropertiesGroups,
  ],
  initialContent: {
    ...metadataConfiguratorInitialContent,
    ...defaultPageInitialContent,
    createNewProject: "Create New Project",
    showConfiguratorNav: true,
  },
  validations: [
    ...defaultPageValidations,
    ...metadataValidations,
    [
      "redirectToProjectCreate",
      (attr) => {
        if (!attr) {
          return {
            message: "RedirectToProjectCreate attribute should be set.",
            severity: "warning",
          };
        }
      },
    ],
    [
      "redirectToProjectItem",
      (attr) => {
        if (!attr) {
          return {
            message: "RedirectToProjectItem attribute should be set.",
            severity: "warning",
          };
        }
      },
    ],
  ],
});
